import { ALL_SITE_BY_USER } from "../apiEndpoints";
import SiteList from "../components/siteList/SiteList";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { useSelector } from "react-redux";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";

const SitesPage = () => {
  const { isLoaded } = useFetchData(ALL_SITE_BY_USER);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout headerConfig={{ title: "Sites" }} numberOfData={dataLength}>
      {isLoaded && !error ? (
        <SiteList sitesData={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default SitesPage;
